/*!
 * fetch-please v0.4.3
 * HTTP-transport that supports Promises and cancelable requests (XHR)
 * @author Alexander Burtsev, https://github.com/albburtsev
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["FetchPlease"] = factory();
	else
		root["FetchPlease"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ERROR_RESOURCE_FAILED = exports.ERROR_RESOURCE_ABORTED = exports.ERROR_CONNECTION_TIMEOUT = exports.ERROR_JSON_PARSE = exports.ERROR_INVALID_DATA = exports.ERROR_UNACCEPTABLE_HTTP_CODE = exports.ERROR_UNKNOWN_HTTP_METHOD = exports.ERROR_PROMISE_NOT_FOUND = exports.ERROR_XHR_NOT_FOUND = exports.MAX_SUCCESSFUL_HTTP_CODE = exports.MIN_SUCCESSFUL_HTTP_CODE = exports.CONTENT_TYPE_JSON = exports.ALLOWED_METHODS = exports.HTTP_METHOD_DELETE = exports.HTTP_METHOD_POST = exports.HTTP_METHOD_PUT = exports.HTTP_METHOD_GET = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _helpers = __webpack_require__(1);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var HTTP_METHOD_GET = exports.HTTP_METHOD_GET = 'GET';
	var HTTP_METHOD_PUT = exports.HTTP_METHOD_PUT = 'PUT';
	var HTTP_METHOD_POST = exports.HTTP_METHOD_POST = 'POST';
	var HTTP_METHOD_DELETE = exports.HTTP_METHOD_DELETE = 'DELETE';
	var ALLOWED_METHODS = exports.ALLOWED_METHODS = [HTTP_METHOD_GET, HTTP_METHOD_PUT, HTTP_METHOD_POST, HTTP_METHOD_DELETE];

	var CONTENT_TYPE_JSON = exports.CONTENT_TYPE_JSON = 'application/json';
	var MIN_SUCCESSFUL_HTTP_CODE = exports.MIN_SUCCESSFUL_HTTP_CODE = 200;
	var MAX_SUCCESSFUL_HTTP_CODE = exports.MAX_SUCCESSFUL_HTTP_CODE = 299;

	var ERROR_XHR_NOT_FOUND = exports.ERROR_XHR_NOT_FOUND = 'Constructor XMLHttpRequest not found';
	var ERROR_PROMISE_NOT_FOUND = exports.ERROR_PROMISE_NOT_FOUND = 'Constructor Promise not found';
	var ERROR_UNKNOWN_HTTP_METHOD = exports.ERROR_UNKNOWN_HTTP_METHOD = 'Unknown HTTP method';
	var ERROR_UNACCEPTABLE_HTTP_CODE = exports.ERROR_UNACCEPTABLE_HTTP_CODE = 'Unacceptable HTTP code';
	var ERROR_INVALID_DATA = exports.ERROR_INVALID_DATA = 'Invalid data for sending';
	var ERROR_JSON_PARSE = exports.ERROR_JSON_PARSE = 'Invalid JSON';

	var ERROR_CONNECTION_TIMEOUT = exports.ERROR_CONNECTION_TIMEOUT = 'Connection timeout';
	var ERROR_RESOURCE_ABORTED = exports.ERROR_RESOURCE_ABORTED = 'Resource has been aborted';
	var ERROR_RESOURCE_FAILED = exports.ERROR_RESOURCE_FAILED = 'Resource failed to load';

	/**
	 * @class HTTP-transport based on XHR
	 * @property {String} path Common path
	 * @property {Number} timeout Timeout (in milliseconds)
	 * @property {Object} headers Common headers
	 * @property {Array} opened List of opened requests
	 * @property {Boolean} cors  Use `withCredentials`
	 * @property {XMLHttpRequest} XMLHttpRequest XHR interface
	 * @property {Boolean} cors ```true``` if supported Cross-Origin Resource Sharing
	 * @see https://xhr.spec.whatwg.org/
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest
	 * @see http://www.html5rocks.com/en/tutorials/cors/
	 */

	var FetchPlease = function () {
	    /**
	     * @param {String} path Common path for all requests
	     * @param {Object} [settings] Object with settings
	     * @param {Number} [settings.timeout = 0]
	     * @param {Object} [settings.XMLHttpRequest = global.XMLHttpRequest]
	     * @param {Object} [settings.cors = false]
	     * @param {Function} [settings.onProgress] Handler for xhr.onprogress
	     * @param {Function} [settings.onProgressUpload] Handler for xhr.upload.onprogress
	     * @param {Object|Function} [settings.headers = {}]
	     */
	    function FetchPlease() {
	        var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	        _classCallCheck(this, FetchPlease);

	        this.path = path;
	        this.opened = [];

	        (0, _helpers.assign)(this, {
	            timeout: 0,
	            headers: {},
	            cors: false,
	            XMLHttpRequest: global.XMLHttpRequest
	        }, settings);

	        var XMLHttpRequest = this.XMLHttpRequest;

	        if (XMLHttpRequest) {
	            this.cors = settings.cors && 'withCredentials' in new XMLHttpRequest();
	        }
	    }

	    /**
	     * Creates XHR instance and Promise instance
	     * @param {String} method HTTP method
	     * @param {String} path
	     * @param {Object} data
	     * @param {Object} settings
	     * @return {Object}
	     */


	    _createClass(FetchPlease, [{
	        key: 'request',
	        value: function request(method, path) {
	            var _this = this;

	            var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	            var settings = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

	            if (!this.XMLHttpRequest) {
	                throw new Error(ERROR_XHR_NOT_FOUND);
	            }

	            if (!global.Promise) {
	                throw new Error(ERROR_PROMISE_NOT_FOUND);
	            }

	            if (ALLOWED_METHODS.indexOf(method) === -1) {
	                throw new Error(ERROR_UNKNOWN_HTTP_METHOD);
	            }

	            var xhr = new this.XMLHttpRequest(),
	                promise = new Promise(function (resolve, reject) {
	                xhr.addEventListener('error', function () {
	                    return reject(ERROR_RESOURCE_FAILED);
	                });
	                xhr.addEventListener('abort', function () {
	                    return reject(ERROR_RESOURCE_ABORTED);
	                });
	                xhr.addEventListener('timeout', function () {
	                    return reject(ERROR_CONNECTION_TIMEOUT);
	                });
	                xhr.addEventListener('load', function () {
	                    if (xhr.status) {
	                        resolve(xhr);
	                    }
	                });
	            });

	            settings = settings || {};

	            var handleJson = settings.handleJson || this.handleJson,
	                handleError = settings.handleError || this.handleError,
	                handleResponse = settings.handleResponse || this.handleResponse;

	            promise = promise
	            // Remove request from list of opened requests
	            .then(function () {
	                return _this.close(xhr);
	            }, function (reason) {
	                _this.close(xhr);
	                throw new Error(reason);
	            })
	            // Handle response
	            .then(handleResponse)
	            // Handle JSON in response
	            .then(handleJson)
	            // Handle errors
	            .catch(handleError);

	            // Add optinal `onProgress` handler
	            if (settings.onProgress) {
	                xhr.addEventListener('progress', settings.onProgress);
	            }

	            // Add optinal `onProgressUpload` handler
	            if (settings.onProgressUpload) {
	                xhr.upload.addEventListener('progress', settings.onProgressUpload);
	            }

	            // Form URL without normalizing and open request
	            var url = this.path + path;
	            xhr.open(method, url);

	            // Set headers
	            // Order of method's calls is important
	            // You must call setRequestHeader() after open(), but before send()
	            // @see: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#setRequestHeader()
	            var headers = (0, _helpers.assign)({}, typeof this.headers === 'function' ? this.headers() : this.headers, settings.headers);
	            this.setHeaders(xhr, headers);

	            // Set timeout (before send() too)
	            // @see https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/Synchronous_and_Asynchronous_Requests#Example_using_a_timeout
	            var timeout = this.timeout || settings.timeout || 0;
	            xhr.timeout = timeout;

	            // Serialize data and send request
	            data = this.serialize(data);

	            if (this.cors) {
	                xhr.withCredentials = true;
	            }

	            xhr.send(data);

	            // Add request into list of opened requests
	            this.add(xhr);

	            return { xhr: xhr, promise: promise };
	        }

	        /**
	         * Serializes data for request
	         * @param {*} data
	         * @return {String|FormData|Blob}
	         */

	    }, {
	        key: 'serialize',
	        value: function serialize(data) {
	            // Do nothing with FormData instance
	            if (global.FormData && data instanceof FormData) {
	                return data;
	            }

	            // Do nothing with Blob instance
	            if (global.Blob && data instanceof Blob) {
	                return data;
	            }

	            // Do nothing with string or null
	            if (data === null || typeof data === 'string') {
	                return data;
	            }

	            try {
	                // Serialize other data as JSON
	                return JSON.stringify(data);
	            } catch (e) {
	                throw new Error(ERROR_INVALID_DATA);
	            }
	        }

	        /**
	         * Iterates given headers and set them for XHR object
	         * @param {XMLHttpRequest} xhr
	         * @param {Object} headers
	         * @return {XMLHttpRequest}
	         */

	    }, {
	        key: 'setHeaders',
	        value: function setHeaders(xhr) {
	            var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            return Object.keys(headers).reduce(function (xhr, header) {
	                var value = headers[header];

	                if (value !== false && value !== null && value !== undefined) {
	                    xhr.setRequestHeader(header, value);
	                }

	                return xhr;
	            }, xhr);
	        }

	        /**
	         * Aborts all opened requests
	         */

	    }, {
	        key: 'abort',
	        value: function abort() {
	            this.opened.forEach(function (xhr) {
	                return xhr.abort();
	            });
	        }

	        /**
	         * Adds request to list of opened requests
	         * @param {XMLHttpRequest} xhr
	         */

	    }, {
	        key: 'add',
	        value: function add(xhr) {
	            this.opened.push(xhr);
	        }

	        /**
	         * Deletes request from list of opened requests
	         * @param {XMLHttpRequest} xhr
	         * @return {XMLHtpRequest}
	         */

	    }, {
	        key: 'close',
	        value: function close(xhr) {
	            var idx = this.opened.indexOf(xhr);
	            if (idx !== -1) {
	                this.opened.splice(idx, 1);
	            }
	            return xhr;
	        }

	        /**
	         * Sends GET request
	         * @param {String} url
	         * @param {Object} [params]
	         * @param {Object} [settings]
	         * @return {Promise}
	         */

	    }, {
	        key: 'get',
	        value: function get(url, params, settings) {
	            var _getRequest = this.getRequest(url, params, settings),
	                promise = _getRequest.promise;

	            return promise;
	        }

	        /**
	         * Sends PUT request
	         * @param {String} url
	         * @param {Object} data
	         * @param {Object} [settings]
	         * @return {Promise}
	         */

	    }, {
	        key: 'put',
	        value: function put(url, data, settings) {
	            var _putRequest = this.putRequest(url, data, settings),
	                promise = _putRequest.promise;

	            return promise;
	        }

	        /**
	         * Sends POST request
	         * @param {String} url
	         * @param {Object} data
	         * @param {Object} [settings]
	         * @return {Promise}
	         */

	    }, {
	        key: 'post',
	        value: function post(url, data, settings) {
	            var _postRequest = this.postRequest(url, data, settings),
	                promise = _postRequest.promise;

	            return promise;
	        }

	        /**
	         * Sends DELETE request
	         * @param {String} url
	         * @param {Object} [params]
	         * @param {Object} [settings]
	         * @return {Promise}
	         */

	    }, {
	        key: 'delete',
	        value: function _delete(url, params, settings) {
	            var _deleteRequest = this.deleteRequest(url, params, settings),
	                promise = _deleteRequest.promise;

	            return promise;
	        }

	        /**
	         * Sends same GET request but returns object with instances of XHR and Promise
	         * @param {String} url
	         * @param {Object} [params]
	         * @param {Object} [settings]
	         * @return {Object}
	         */

	    }, {
	        key: 'getRequest',
	        value: function getRequest(url) {
	            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	            url = (0, _helpers.joinParams)(url, params);
	            return this.request(HTTP_METHOD_GET, url, null, settings);
	        }

	        /**
	         * Sends same PUT request but returns object with instances of XHR and Promise
	         * @param {String} url
	         * @param {Object} data
	         * @param {Object} [settings]
	         * @return {Object}
	         */

	    }, {
	        key: 'putRequest',
	        value: function putRequest(url, data) {
	            var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	            return this.request(HTTP_METHOD_PUT, url, data, settings);
	        }

	        /**
	         * Sends same POST request but returns object with instances of XHR and Promise
	         * @param {String} url
	         * @param {Object} data
	         * @param {Object} [settings]
	         * @return {Object}
	         */

	    }, {
	        key: 'postRequest',
	        value: function postRequest(url, data) {
	            var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	            return this.request(HTTP_METHOD_POST, url, data, settings);
	        }

	        /**
	         * Sends same DELETE request but returns object with instances of XHR and Promise
	         * @param {String} url
	         * @param {Object} [params]
	         * @param {Object} [settings]
	         * @return {Object}
	         */

	    }, {
	        key: 'deleteRequest',
	        value: function deleteRequest(url) {
	            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	            url = (0, _helpers.joinParams)(url, params);
	            return this.request(HTTP_METHOD_DELETE, url, null, settings);
	        }

	        /**
	         * Handles JSON in response
	         * @param {XMLHttpRequest} xhr
	         * @param {String} xhr.responseText
	         * @return {Object}
	         */

	    }, {
	        key: 'handleJson',
	        value: function handleJson(xhr) {
	            var responseText = xhr.responseText,
	                contentType = xhr.getResponseHeader('Content-Type') || '';


	            contentType = contentType.toLowerCase();

	            // If header Content-Type has value "application/json" then parse text as JSON
	            if (contentType.indexOf(CONTENT_TYPE_JSON) !== -1) {
	                try {
	                    return JSON.parse(responseText);
	                } catch (e) {
	                    throw new Error(ERROR_JSON_PARSE);
	                }
	            }

	            // Just return given xhr
	            return xhr;
	        }

	        /**
	         * Handles XHR response
	         * @param {XMLHttpRequest} xhr
	         * @param {Number} xhr.status
	         * @see https://xhr.spec.whatwg.org/#interface-xmlhttprequest
	         * @return {XMLHttpRequest}
	         */

	    }, {
	        key: 'handleResponse',
	        value: function handleResponse(xhr) {
	            var status = xhr.status;

	            // If status < 200 or status >= 200 then return error

	            if (status < MIN_SUCCESSFUL_HTTP_CODE || status > MAX_SUCCESSFUL_HTTP_CODE) {
	                var error = new Error(ERROR_UNACCEPTABLE_HTTP_CODE);
	                error.statusCode = status;
	                throw error;
	            }

	            // Just return given xhr
	            return xhr;
	        }

	        /**
	         * Handles any occured errors
	         * @param {Error} error
	         * @return {Error}
	         */

	    }, {
	        key: 'handleError',
	        value: function handleError(error) {
	            // Really do nothing
	            throw error;
	        }
	    }]);

	    return FetchPlease;
	}();

	exports.default = FetchPlease;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.assign = assign;
	exports.joinParams = joinParams;
	/**
	 * Naive polyfill for Object.assign()
	 * Why I did it? Because even modular lodash adds too much code in final build
	 * @param {Object} target
	 * @return {Object}
	 */
	function assign(target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var obj = Object(arguments[i]),
	            keys = Object.keys(obj);

	        for (var j = 0; j < keys.length; j++) {
	            var key = keys[j];

	            if (!obj.hasOwnProperty(key)) {
	                continue;
	            }

	            target[key] = obj[key];
	        }
	    }

	    return target;
	}

	/**
	 * Returns URL with query string
	 * @param {String} url
	 * @param {Object} params
	 * @return {String}
	 */
	function joinParams(url) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	    if (!params) {
	        return url;
	    }

	    var queryString = Object.keys(params).filter(function (key) {
	        var value = params[key];
	        return value !== null && value !== undefined;
	    }).map(function (key) {
	        var value = params[key].toString();

	        key = encodeURIComponent(key);
	        value = encodeURIComponent(value);

	        return key + '=' + value;
	    }).join('&');

	    if (!queryString) {
	        return url;
	    }

	    // Trim trailing "?"
	    url = url.replace(/\?+$/, '');

	    return url + (url.indexOf('?') === -1 ? '?' : '&') + queryString;
	}

/***/ }
/******/ ])
});
;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fetch-please/dist/fetch-please.js
// module id = 628
// module chunks = 0 1